'use client'

import cn from 'clsx'
import { useRect } from 'hamo'
import { useState } from 'react'
import { Image } from '~/components/image'
import { useDeviceDetection } from '~/hooks/use-device-detection'
import { useScrollTrigger } from '~/hooks/use-scroll-trigger'
import { WebGLTunnel } from '~/webgl/components/tunnel'
import { WebGLDepthImage } from './webgl'

// const WebGLDepthImage = dynamic(
//   () => import('./webgl').then(({ WebGLDepthImage }) => WebGLDepthImage),
//   {
//     ssr: false,
//   },
// )

export function DepthImage({ className, src, depthSrc, onInView, ...props }) {
  const [setRectRef, rect] = useRect()
  const { isDesktop } = useDeviceDetection()
  const [currentSrc, setCurrentSrc] = useState(null)
  const [isLoaded, setIsLoaded] = useState(false)

  useScrollTrigger({
    rect,
    start: 'top center',
    disable: !isDesktop,
    onEnter: () => {
      onInView?.()
    },
  })

  return (
    <div ref={setRectRef} className={cn(className, 'relative')}>
      <Image
        src={src}
        alt=""
        onLoad={(e) => {
          setCurrentSrc(e.target.currentSrc)
        }}
        fill
        {...props}
        style={{
          opacity: currentSrc && isLoaded ? 0 : 1,
        }}
      />
      {isDesktop && depthSrc && (
        <WebGLTunnel>
          {currentSrc && (
            <WebGLDepthImage
              rect={rect}
              onLoad={() => {
                setIsLoaded(true)
              }}
              src={currentSrc}
              depthSrc={depthSrc}
            />
          )}
        </WebGLTunnel>
      )}
    </div>
  )
}
